// Func = limiting Scope for this file
var lastScrollTop = 0;
var CLICK_COUNTER = 0;


(function() {

    // let form_id_3711 = document.querySelector( "#form_id-3727 #form_id-3727-yes-signup-formemail-signup" );
    // if( form_id_3711 ){
    //     form_id_3711.classList.add( "required" )
    //     form_id_3711.checked = true
    //     form_id_3711.parentElement.classList.add( "hidden" )
    // }

    // POPULATE 2ND NAV CLONES
    document.querySelectorAll('.js-secondaryNav').forEach(nav => {
        document.querySelectorAll('.secondary-navigation__item').forEach(item => nav.innerHTML += `<li>${item.innerHTML}</li>`);
    });

    let form_id_3727_yes_signup_formemail_signup = document.querySelector( "#form_id-3727-yes-signup-formemail-signup" )
    if( form_id_3727_yes_signup_formemail_signup )
        form_id_3727_yes_signup_formemail_signup.classList.add( "required" )

    if ($(".form-module-wrapper .form-module input#id_1_1312").length > 0) {
        // Create a Instagram Button in forms from CMS
        var InstaButton = $(".form-module-wrapper .form-module input#id_1_1312").attr('name').indexOf("nstagram") >= 0;
        if (InstaButton == true) {
            $("<a href='https://www.instagram.com/theloutrelcharleston/' target='_blank' class='insta_button btn'>Follow Us on Instagram</a>").insertBefore($(".form-module-wrapper .form-module .form-module__submit"));
        }
    }

    //is explorer
    function msieversion() {

        var ua = window.navigator.userAgent;
        var msie = ua.indexOf("MSIE ");
        if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./)) {
            const image_fit = document.getElementsByTagName('figure');
            for (let i = 0; i < image_fit.length; i++) {
                const this_image = image_fit[i].getElementsByTagName('img')[0];
                const image_data = this_image.dataset.srcset;
                const image_src = this_image.getAttribute('src');
                image_fit[i].classList.add('ie-bg');
                if (image_data) {
                    image_fit[i].style.backgroundImage = 'url("' + image_data + '")';
                } else {
                    image_fit[i].style.backgroundImage = 'url("' + image_src + '")';

                }
            }
        } else {
            //console.log('other browser');
        }
        return false;
    }

    msieversion();

    $(".form-module-wrapper form").addClass('animate-fade top');
    $(".text-modules-wrapper .text-modules").addClass('animate-fade top');

    //flowers animations
    // if(document.getElementsByClassName('flower-container').length > 0){

    // 	var svgContainer1 = document.getElementById('flowerContainer');
    // 	var animItem1 = lottie.loadAnimation({
    // 		wrapper: svgContainer1,
    // 		animType: 'svg',
    // 		loop: true,
    // 		path: 'flower4.json'
    // 	});


    // }

    // RESTAURANT MENUS FILTER
    document.querySelectorAll('.restMenus_filter button').forEach((btn, i) => {
        btn.addEventListener('click', _ => {
            document.querySelectorAll('.restMenus_filter button').forEach(b => b.classList.remove('active'));
            btn.classList.add('active');

            document.querySelectorAll('.restMenus_item').forEach(room => {
                room.classList.remove('active');
                if (btn.dataset.tag === 'all' || btn.dataset.tag === room.dataset.tag) {
                    room.classList.add('active');
                }
            });
        });

        if (i === 0) btn.click();
    });


    $(document).ready(function() {

        // Main Nav Dropdown
        /*$("#primary-nav li").hover(function(){
        	$(this).addClass("hover");
        	$('ul.submenu',this).fadeIn(200);
        }, function(){
        	$(this).removeClass("hover");
        	$('ul.submenu',this).fadeOut(200);
        });*/
        //Properties Day's Calendar [Enable/Disable,ClassName,Tooltip]
        let DATE_STYLE = [true];

        function calendarRange(date) {
            let d1 = $.datepicker.parseDate(DATE_FORMAT, $('#CheckIn').val());
            let d2 = $.datepicker.parseDate(DATE_FORMAT, $('#CheckOut').val());
            if (d1 && date.getTime() == d1.getTime() || d2 && date.getTime() == d2.getTime()) {
                DATE_STYLE[1] = 'highlight-top';
            } else if (date > d1 && date < d2) {
                DATE_STYLE[1] = 'highlight';
            } else {
                DATE_STYLE[1] = '';
            }
            return DATE_STYLE;
        }


        //Check in and check out datepicker for booking engine	
        const DATE_FORMAT = ($("#CheckIn").data("format") !== undefined && $("#CheckIn").data("format")) ? $("#CheckIn").data("format") : "yy-mm-dd";
        $("#CheckIn").datepicker({
            //showOn: "both",
            //buttonImage: SITE_FILES+"images/img-calendar-gray.png",
            //buttonImageOnly: true,
            changeMonth: true,
            dateFormat: DATE_FORMAT,
            numberOfMonths: 1,
            minDate: 0,
            beforeShowDay: (date) => calendarRange(date),
            onSelect: function(selectedDate) {
                let getDate = $(this).datepicker('getDate');
                let newDate = new Date(getDate.getTime());
                newDate.setDate(newDate.getDate() + 3);
                $("#CheckOut").datepicker("setDate", newDate);
                $("#CheckOut").datepicker("option", "minDate", selectedDate);
            }
        });
        $("#CheckOut").datepicker({
            //showOn: "both",
            //buttonImage: SITE_FILES+"images/img-calendar-gray.png",
            //buttonImageOnly: true,
            dateFormat: DATE_FORMAT,
            changeMonth: true,
            numberOfMonths: 1,
            beforeShowDay: (date) => calendarRange(date),
            onSelect: function(selectedDate) {
                //$( "#CheckIn" ).datepicker( "option", "maxDate", selectedDate );
            }
        });
        // Map: Return to previous page button. Change body id to match map template's name.
        //$('body#map-category-sidebar #content').prepend('<a class="btn return-from-map" href="javascript:history.back()">« Back to previous page</a>');

        let MenuBtn = document.getElementById('menu-btn');
        let Navigation = document.getElementById('navigation');
        let CloseMenu = document.getElementById('close_menu');
        let Body = document.getElementsByTagName('body')[0];

        if (MenuBtn) {
            $(MenuBtn).click(function(event) {
                event.preventDefault();
                Navigation.classList.add('open');
                Body.classList.add('scroll-no');
            });
            $(CloseMenu).click(function(event) {
                event.preventDefault();
                Navigation.classList.remove('open');
                Body.classList.remove('scroll-no');
            });
        }

    });

    window.onload = function() {
        /*this function add a class to header when scroll down the page
        /* and change the logo by a new file if needed depending of mockup
        */

        // scrollDownAction(20, 'scroll');

        scrollW();
        window.addEventListener('scroll', function() {
            scrollW();
        })
    };

    

    if(document.getElementById('socialLinks')){
        let SOCIAL_LINKS = document.getElementById('socialLinks').querySelectorAll('a');
        SOCIAL_LINKS.forEach(link=>{ link.addEventListener('click', function(){CLICK_COUNTER++;})})
    }

}());

function scrollW() {
    //check scroll down or up for header styles
    let st = window.pageYOffset || document.documentElement.scrollTop;
    if (st > 80) {
        if (st > lastScrollTop) {
            // downscroll code
            if (!document.getElementById('header').classList.contains('down')) {
                document.getElementById('header').classList.add('down');
                document.getElementById('header').classList.remove('up');
            }
        } else {
            // upscroll code
            if (!document.getElementById('header').classList.contains('up')) {
                document.getElementById('header').classList.add('up');
                document.getElementById('header').classList.remove('down');
            }
        }
    } else {
        if (document.getElementById('header').classList.contains('up') || document.getElementById('header').classList.contains('down')) {
            document.getElementById('header').classList.remove('up');
            document.getElementById('header').classList.remove('down');
        }
    }
    lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}

function checkSocial(e){
    let SOCIAL_LINKS = document.getElementById('socialLinks').querySelectorAll('a');
    if(CLICK_COUNTER < SOCIAL_LINKS.length){
        e.preventDefault();
    }
}